// {[displayName], [quizlerName]}
const SCORENAME_MAPPING = {
    "Weight Change": "weightVariation",
    "Healthy Eating Habits": "healthyEatingHabits",
    "Sustainability": "sustainability",
    "Whole-Body Health": "wholeBodyHealth",
    "Nutrition Quality": "nutritionQuality",
    "Evidence-Based": "evidenceBased"
}

export default SCORENAME_MAPPING;